import {useRecoilState, useRecoilValue} from "recoil";
import { topMenuTypeState} from "../recoil/menuState/topMenuState";
import {useNavigate} from "react-router-dom";
import {teacherNameState} from "../recoil/teacher/teacherIdState";
import {mainClassState} from "../recoil/classes/classesState";
import TopSettingBtn from "../assets/images/top_setting_btn.png"
import TopLoginOutBtn from "../assets/images/top_logout_btn.png"
import {getCookie} from "../cookie/Cookie";
import {useAuthActions} from "../features/auth/AuthAction";
import {useEffect, useState} from "react";
import {authState} from "../recoil/auth/authState";
import {checkToast} from "./Toast";
import {updateTeacherInfo} from "../network/Endpoint";
import TermsModal from "./TermsModal";
import {TermsOfServiceConsentText} from "./consentText/TermsOfServiceConsentText";
import {PersonalInformationProvisionConsentText} from "./consentText/PersonalInformationProvisionConsentText";
import {MarketingConsent} from "./consentText/MarketingConsent";
import TopMenuSelectedBack from "../assets/images/top_menu_selected_back.svg"
import ClassChangeModal from "./ClassChangeModal";

const TopMenu = () => {
    const [teacherName, setTeacherName] = useRecoilState(teacherNameState);
    const mainClass = useRecoilValue(mainClassState);
    const navigate = useNavigate();
    const { authLogoutAsync } = useAuthActions();
    const auth = useRecoilValue(authState);
    const menuType = useRecoilValue(topMenuTypeState);
    const [showTermsOfServiceModal, setShowTermsOfServiceModal] = useState(false);
    const [termsType, setTermsType] = useState('');
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [showClassChangeModal, setShowClassChangeModal] = useState(false);


    const preStyle = {
        whiteSpace: 'pre-wrap',     // 줄바꿈을 유지하면서 부모의 가로값에 맞게 텍스트 감싸기
        wordWrap: 'break-word',      // 긴 단어가 있을 경우 단어 단위로 줄바꿈
        overflow: 'auto',            // 내용이 넘칠 경우 스크롤 생성
        padding: '10px',             // 내부 여백(optional)
        border: '1px solid #ccc' ,    // 테두리(optional)
    };

    const selectMenu = (selectedPath) =>{
        const pathArray = window.location.pathname.split('?')[0].split('/');
        const path = pathArray.includes("page") ? pathArray[2] : pathArray[1];
        navigate("/page/"+selectedPath);
    }

    const logout = () => {
        const authCookie = getCookie("auth");

        authLogoutAsync( authCookie )
            .then(() => {
                window.location.href = `${process.env.REACT_APP_IS_OAUTH2_LOGOUT_URL}`;
            })
            .catch((error) => {
                console.error("로그아웃 실패:", error);
            });
    }

    // 초기 상태: 전체 체크박스와 개별 체크박스 상태 저장
    const [checks, setChecks] = useState({
        selectAll: false,
        required1: false,
        required2: false,
        optional: false,
    });

    // '전체 체크' 박스 핸들러: 클릭 시 4개 체크박스 모두 체크/해제
    const handleSelectAllChange = (e) => {
        const checked = e.target.checked;
        setChecks({
            selectAll: checked,
            required1: checked,
            required2: checked,
            optional: checked,
        });
    };

    const openTermsModal = (termsType) => {
        setTermsType(termsType);
        setShowTermsModal(true);
    };


    // 개별 체크박스 핸들러
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        // 기존 상태를 복사하여 해당 체크박스의 상태만 변경
        const newChecks = {
            ...checks,
            [name]: checked,
        };
        // 모든 개별 체크박스(필수 1 + 선택 1)가 체크되었으면 전체 체크도 true로 업데이트
        newChecks.selectAll = newChecks.required
        // && newChecks.optional
        ;
        setChecks(newChecks);
    };


    const agreeTermsOfService = async () => {
        if (!checks.required1 || !checks.required2) {
            checkToast('필수 약관을 동의해 주세요.');
            return;
        }
        const request = {
            isTermsOfServiceAgreed: true,
            isMarketingAgreed: checks.optional,
        }
        const body = {
            request: request,
            teacherId: auth.teacher?.teacherId,
        };
       const data = await updateTeacherInfo(body);
       if (data?.skip) return;
        setShowTermsOfServiceModal(false);
    };


    useEffect(() => {
        if(auth){
            if(!auth.teacher.isTermsOfServiceAgreed){
                // console.log(auth);
                setShowTermsOfServiceModal(true);
            }
            setTeacherName(auth.teacher.name);
        }
    },[]);

    return (
        <div
            className="flex flex-row justify-between items-center self-stretch py-6 w-full bg-white max-md:pr-5 max-md:max-w-full">
            {/* 로고 */}
            <div
                className="flex flex-col justify-center items-start ml-20 max-w-full min-h-[36px] w-[300px] max-md:pl-5">
                <img loading="lazy" src="/logo_IC_math.svg" alt="Company Logo"
                     className="object-contain w-max aspect-[3.12] cursor-pointer"
                     onClick={() => selectMenu("home")}/>
            </div>
            <div className="flex flex-row justify-around items-center gap-8 w-[710px] relative z-10">
                {["home", "classLesson", "classAttendance", "management", "license"].map(
                    (menu) => (
                        <div
                            key={menu}
                            className="relative flex flex-col items-center cursor-pointer"
                            onClick={() => selectMenu(menu)}
                        >
                            {/* 배경 애니메이션 */}
                            <div
                                className={`absolute bottom-[-30px] w-max h-max transition-transform duration-700 ease-in-out origin-bottom rounded-t-[40px] z-[-1] 
                ${menuType === menu ? "scale-y-100 opacity-100" : "scale-y-0 opacity-0"}`}
                                style={{
                                    transform: menuType === menu ? "scaleY(1)" : "scaleY(0)",
                                    transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
                                }}
                            >
                                    <img
                                        className=""
                                        src={TopMenuSelectedBack}
                                        alt="topMenuSelectedBack"/>
                            </div>
                            {/* 메뉴 텍스트 */}
                            <div
                                className={`font-bold transition-all duration-500 h-[84px] flex items-center justify-center w-[120px]  ${
                                    menuType === menu ? "text-[#355BDF]" : "text-[#50555F]"
                                }`}
                            >
                                {menu === "home"
                                    ? "홈"
                                    : menu === "classLesson"
                                        ? (<>
                                            학습 분석<br/>(학급)
                                        </>)
                                        : menu === "classAttendance"
                                            ? (<>학습 분석<br/>(개인)</>)
                                            : menu === "management"
                                                ? (<>클래스/학생<br/>관리</>)
                                                : (<>이용권<br/>등록/관리</>)}
                            </div>
                        </div>
                    )
                )}
            </div>
            <div className="flex flex-col justify-center items-center mr-20 w-[300px] gap-[6px]">
                <div className="flex  justify-end text-black text-[18px] font-[700] w-full whitespace-nowrap">
                    <span className="w-max">{teacherName && teacherName},</span>&nbsp;<span
                    className="truncate min-w-0 w-max">{mainClass && mainClass.name}</span>
                </div>
                <div className="flex flex-row  justify-end items-center gap-5 w-full">
                    <div
                        className="flex flex-row cursor-pointer items-center gap-1"
                        onClick={() => setShowClassChangeModal(true)}
                    >
                        <img
                            className="w-max h-max"
                            src={TopSettingBtn}
                            alt="setting btn"/>
                        <div className="flex text-[#355BDF] text-[16px] font-[700]">클래스 변경</div>
                    </div>
                    <div
                        className="flex flex-row cursor-pointer items-center gap-1"
                        onClick={() => logout()}
                    >
                        <img
                            className="w-max h-max"
                            src={TopLoginOutBtn}
                            alt="setting btn"/>
                        <div className="flex text-[#355BDF] text-[16px] font-[700]">로그아웃</div>

                    </div>
                </div>
            </div>
            {/*클래스 변경 모달*/}
            <ClassChangeModal showClassChangeModal={showClassChangeModal} setShowClassChangeModal={setShowClassChangeModal}/>
            {/*이용약관 동의 모달*/}
            <TermsModal showTermsModal={showTermsModal} setShowTermsModal={setShowTermsModal} termsType={termsType}/>
            {showTermsOfServiceModal ? (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1010]">
                    <div className={'w-[936px] px-[80px] bg-white rounded-[20px] overflow-auto max-h-[90%]'}>
                        <div className={'mt-[30px]'}>
                            <div className={'text-[36px] font-[pd-eb] flex justify-center items-center'}>
                                약관 동의
                            </div>
                            <div className={'mt-[20px] text-center'}>
                                서비스를 이용하기 위해서는 아래 약관에 대한 동의가 필요합니다.
                            </div>
                            <div className={'mt-[20px] text-left'}>
                                <div>
                                    <label className={'flex items-center cursor-pointer select-none'}>
                                        <input
                                            type="checkbox"
                                            name="selectAll"
                                            checked={checks.selectAll}
                                            onChange={handleSelectAllChange}
                                            className={'w-[32px] h-[32px]'}
                                        />
                                        <div className={'text-[24px] font-[pd-eb] ml-[10px] font-[700]'}>
                                            전체 동의
                                        </div>
                                    </label>
                                </div>
                                <div className={'flex justify-between items-center mt-[10px] text-left'}>
                                    <label className={'flex items-center cursor-pointer select-none'}>
                                        <input
                                            type="checkbox"
                                            name="required1"
                                            checked={checks.required1}
                                            onChange={handleCheckboxChange}
                                            className={'w-[18px] h-[18px]'}
                                        />
                                        <div className={'w-[500px] ml-[6px]'}>
                                            개인정보 수집•이용 동의 <span className={'text-[#FC5955]'}>(필수)</span>
                                        </div>
                                    </label>
                                    {/*<div onClick={() => openTermsModal('personalInfoCollectionAndUseConsent')}*/}
                                    {/*     className={'w-[200px] h-[14px] cursor-pointer flex justify-center'}>*/}
                                    {/*    자세히 보기*/}
                                    {/*</div>*/}

                                </div>
                                <pre style={preStyle}
                                     className={'h-[130px]'}>{TermsOfServiceConsentText}</pre>
                                <div className={'mt-[10px]'}>
                                    <label className={'flex items-center cursor-pointer select-none'}>
                                        <input
                                            type="checkbox"
                                            name="required2"
                                            checked={checks.required2}
                                            onChange={handleCheckboxChange}
                                            className={'w-[18px] h-[18px]'}
                                        />
                                        <div className={'w-[500px] ml-[6px]'}>
                                            개인정보 제공 동의 <span className={'text-[#FC5955]'}>(필수)</span>
                                        </div>
                                    </label>
                                    {/*<pre style={preStyle}*/}
                                    {/*     className={'h-[130px]'}>{personalInformationProvisionConsentText}</pre>*/}
                                </div>
                                <pre style={preStyle}
                                     className={'h-[130px]'}>{PersonalInformationProvisionConsentText}</pre>
                                <div className={'flex justify-between items-center mt-[10px]  text-left'}>
                                    <label className={'flex items-center cursor-pointer select-none'}>
                                        <input
                                            type="checkbox"
                                            name="optional"
                                            checked={checks.optional}
                                            onChange={handleCheckboxChange}
                                            className={'w-[18px] h-[18px]'}
                                        />
                                        <div className={'w-[500px] ml-[6px]'}>
                                            마케팅 활용 동의 <span className={'text-[#FC5955]'}>(선택)</span>
                                        </div>
                                    </label>
                                    {/*<div onClick={() => openTermsModal('marketingConsent')}*/}
                                    {/*     className={'w-[200px] h-[14px] cursor-pointer flex justify-center'}>*/}
                                    {/*    자세히 보기*/}
                                    {/*</div>*/}
                                </div>
                                <pre style={preStyle}
                                     className={'h-[130px]'}>{MarketingConsent}</pre>
                            </div>
                        </div>
                        <div className={'mt-[30px] flex justify-center items-center'}>
                            <div
                                className={'w-full h-[50px] border rounded-[100px] cursor-pointer select-none flex justify-center items-center font-[pd-b] bg-[#355BDF] text-[#ffffff] mb-8'}
                                onClick={() => agreeTermsOfService()}>동의함
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default TopMenu;